<template>
    <el-form>
        <div class="simple-form">
            <div v-for="merchantQualiAttrVal in merchantQualiAttrValList" class="form-group center">
                <div class="form-label">
                    <label>{{merchantQualiAttrVal.hintInfo}}</label>
                </div>
                <div class="form-value width-1-5x" v-if="merchantQualiAttrVal.type == 5">
                    <span v-for="qualiAttrVal in merchantQualiAttrVal.qualiAttrVal">{{qualiAttrVal}}&nbsp;</span>
                </div>
                <div class="form-value width-1-5x" v-else>
                    <span>{{merchantQualiAttrVal.qualiAttrVal}}</span>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import merchtQualiApi from '../../api/merchtQuali'

    export default {
        name: 'swb-quali-attr-val-search',
        desc: '交易属性值-搜索',
        props: ['id'],
        data: function () {
            return {
                qualiType: {},
                typeId: null,
                typeName: null,
                merchantQuali: {},
                merchantQualiAttrValList: [],
                auditState: "1",
                auditDesc: null,
            }
        },
        created: function () {
            let self = this;
            self.getApplyMerchantQuali();
        },
        methods: {
            getQualiAttrList: function () {
                let self = this;
                let postData = {};
                let typeId = self.typeId;
                postData.typeId = typeId;
                //
                console.error("开发人员混蛋，搞了个无效 api方法");
                ///quali/attr/list/get/by/typeId
//                merchtComnApi.getQualiTypeAttrOptionList(postData, function (result) {
//                    if(result.type == 'info') {
//                        let qualiType = result.data;
//                        let merchantQualiAttrValList = self.merchantQuali.merchantQualiAttrValList;
//                        if(merchantQualiAttrValList != null && merchantQualiAttrValList.length > 0) {
//                            if(qualiType.qualiTypeAttrList != null && qualiType.qualiTypeAttrList.length > 0) {
//                                for(let i = 0; i < merchantQualiAttrValList.length; i++) {
//                                    let merchantQualiAttrVal = merchantQualiAttrValList[i];
//                                    for(let j = 0; j < qualiType.qualiTypeAttrList.length; j++) {
//                                        let qualiTypeAttr = qualiType.qualiTypeAttrList[j];
//                                        let qualiAttr = qualiTypeAttr.qualiAttr;
//                                        if(merchantQualiAttrVal.qualiAttrId == qualiAttr.id) {
//                                            if(qualiAttr.type == 5) {
//                                                let qualiAttrValList = merchantQualiAttrVal.qualiAttrVal;
//                                                let qualiAttrVal = qualiAttrValList.split("|");
//                                                merchantQualiAttrVal.qualiAttrVal = qualiAttrVal;
//                                                merchantQualiAttrVal.type = qualiAttr.type;
//                                                merchantQualiAttrVal.hintInfo = qualiTypeAttr.hintInfo;
//                                            } else {
//                                                merchantQualiAttrVal.qualiAttrVal = merchantQualiAttrVal.qualiAttrVal;
//                                                merchantQualiAttrVal.type = qualiAttr.type;
//                                                merchantQualiAttrVal.hintInfo = qualiTypeAttr.hintInfo;
//                                            }
//                                        }
////                                        qualiTypeAttr.fileTagItems = '';
//
//                                    }
//                                }
//                            }
//                        }
//                        self.merchantQualiAttrValList = merchantQualiAttrValList;
//
//                    }
//                });
            },
            getApplyMerchantQuali: function () {
                let self = this;
                let postData = {};
                postData.qualiTypeId = self.id;
                let loading = MsgBox.loading();
                merchtQualiApi.getMerchantQualiInfoByMerchantIdAndQualiTypeId(postData, function (result) {
                    loading.close();
                    if(result.type === 'info') {
                        self.merchantQuali = result.data;
                        self.typeId = self.merchantQuali.qualiTypeId;
                        self.getQualiAttrList();
                    }
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/quali/QualiAttrValSearch.vue